import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { LegalFooter } from "./Impressum";
import { usePageMeta } from "../hooks/usePageMeta";

const sections = [
  {
    title: "1. Verantwortlicher",
    text: `Verantwortlicher im Sinne der Datenschutz-Grundverordnung (DSGVO) ist:

Langebach GbR
Pirate Bowling Center
Hainstraße 4
92355 Velburg

E-Mail: info@pirate-bowling.com
Telefon: 09182 / 938936

Vertreten durch: Ralf Langebach, Angelika Langebach`,
    testId: "datenschutz-verantwortlicher",
  },
  {
    title: "2. Allgemeines zur Datenverarbeitung",
    text: `Wir nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.

Die Nutzung unserer Website ist in der Regel ohne Angabe personenbezogener Daten möglich. Soweit auf unseren Seiten personenbezogene Daten erhoben werden, erfolgt dies stets auf freiwilliger Basis. Eine Weitergabe an Dritte ohne Ihre ausdrückliche Einwilligung findet nicht statt.

Wir weisen darauf hin, dass die Datenübertragung im Internet (z. B. bei der Kommunikation per E-Mail) Sicherheitslücken aufweisen kann. Ein lückenloser Schutz der Daten vor dem Zugriff durch Dritte ist nicht möglich.`,
    testId: "datenschutz-allgemein",
  },
  {
    title: "3. Rechtsgrundlagen der Verarbeitung",
    text: `Die Verarbeitung personenbezogener Daten erfolgt auf Grundlage folgender Rechtsgrundlagen:

• Art. 6 Abs. 1 lit. a DSGVO – Einwilligung: Soweit Sie uns eine Einwilligung zur Verarbeitung erteilt haben.
• Art. 6 Abs. 1 lit. b DSGVO – Vertragserfüllung: Soweit die Verarbeitung zur Erfüllung eines Vertrages oder vorvertraglicher Maßnahmen erforderlich ist (z. B. Reservierungen).
• Art. 6 Abs. 1 lit. f DSGVO – Berechtigtes Interesse: Soweit die Verarbeitung zur Wahrung eines berechtigten Interesses unseres Unternehmens erforderlich ist (z. B. Betrieb und Sicherheit der Website).`,
    testId: "datenschutz-rechtsgrundlagen",
  },
  {
    title: "4. SSL-/TLS-Verschlüsselung",
    text: `Diese Seite nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte eine SSL- bzw. TLS-Verschlüsselung. Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von „http://" auf „https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.

Wenn die SSL- bzw. TLS-Verschlüsselung aktiviert ist, können die Daten, die Sie an uns übermitteln, nicht von Dritten mitgelesen werden.`,
    testId: "datenschutz-ssl",
  },
  {
    title: "5. Hosting und Server-Logfiles",
    text: `Diese Website wird bei Cloudflare, Inc. (101 Townsend St, San Francisco, CA 94107, USA) gehostet. Beim Besuch unserer Website werden durch den Hosting-Anbieter automatisch Informationen in sogenannten Server-Logfiles erfasst, die Ihr Browser automatisch übermittelt. Dies sind:

• Browsertyp und Browserversion
• Verwendetes Betriebssystem
• Referrer URL (zuvor besuchte Seite)
• IP-Adresse des zugreifenden Rechners
• Uhrzeit der Serveranfrage

Diese Daten werden für den sicheren Betrieb der Website benötigt und spätestens nach 14 Tagen automatisch gelöscht. Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen.

Die Datenverarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einem sicheren Betrieb der Website). Cloudflare ist unter dem EU-US Data Privacy Framework zertifiziert, was ein angemessenes Datenschutzniveau gewährleistet.`,
    testId: "datenschutz-hosting",
  },
  {
    title: "6. Cookies",
    text: `Unsere Website verwendet Cookies. Das sind kleine Textdateien, die auf Ihrem Endgerät gespeichert werden und die Ihr Browser speichert.

Wir unterscheiden zwischen:

• Technisch notwendige Cookies: Diese sind erforderlich, damit die Website ordnungsgemäß funktioniert (z. B. Cookie-Einstellungen merken). Rechtsgrundlage: Art. 6 Abs. 1 lit. f DSGVO.
• Optionale Cookies: Diese werden nur mit Ihrer ausdrücklichen Einwilligung gesetzt. Rechtsgrundlage: Art. 6 Abs. 1 lit. a DSGVO.

Beim ersten Besuch unserer Website werden Sie über ein Cookie-Banner über den Einsatz von Cookies informiert und um Ihre Einwilligung gebeten. Sie können Ihre Einwilligung jederzeit über den Link „Cookie-Einstellungen" im Footer unserer Website widerrufen.

Sie können Ihren Browser auch so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben bzw. generell ausschließen. Bitte beachten Sie, dass bei Deaktivierung von Cookies die Funktionalität unserer Website eingeschränkt sein kann.`,
    testId: "datenschutz-cookies",
  },
  {
    title: "7. Kontaktaufnahme",
    text: `Wenn Sie uns per E-Mail oder Telefon kontaktieren, werden Ihre Angaben einschließlich der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.

Die Verarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (vorvertragliche Maßnahmen) bzw. Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an der Beantwortung Ihrer Anfrage).`,
    testId: "datenschutz-kontakt",
  },
  {
    title: "8. WhatsApp",
    text: `Auf unserer Website bieten wir die Möglichkeit, uns über WhatsApp (Meta Platforms Ireland Ltd., 4 Grand Canal Square, Dublin 2, Irland) zu kontaktieren. Wenn Sie den WhatsApp-Button anklicken, werden Sie zu WhatsApp weitergeleitet. Dabei wird Ihre Telefonnummer an WhatsApp übermittelt.

Die Nutzung von WhatsApp erfolgt auf Grundlage Ihrer Einwilligung gemäß Art. 6 Abs. 1 lit. a DSGVO. Die Datenschutzhinweise von WhatsApp finden Sie unter: https://www.whatsapp.com/legal/privacy-policy-eea`,
    testId: "datenschutz-whatsapp",
  },
  {
    title: "9. Online-Reservierung (4bowl.de)",
    text: `Für die Online-Reservierung von Bowlingbahnen nutzen wir den externen Dienst 4bowl.de. Wenn Sie den Reservierungslink anklicken, werden Sie auf die Plattform von 4bowl.de weitergeleitet. Dort gelten die Datenschutzbestimmungen des jeweiligen Anbieters.

Wir haben keinen Einfluss auf die Datenerhebung und -verarbeitung durch 4bowl.de. Bitte informieren Sie sich auf der Website des Anbieters über dessen Datenschutzpraktiken.`,
    testId: "datenschutz-reservierung",
  },
  {
    title: "10. Virtueller Rundgang (Matterport)",
    text: `Auf unserer Website ist ein virtueller 3D-Rundgang eingebunden, der über den Dienst Matterport, Inc. (352 E. Java Dr., Sunnyvale, CA 94089, USA) bereitgestellt wird. Beim Laden des Rundgangs wird eine Verbindung zu den Servern von Matterport hergestellt, wobei Ihre IP-Adresse und ggf. weitere Browserdaten übertragen werden. Matterport kann dabei Cookies setzen.

Die Einbindung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse an einer ansprechenden Darstellung unseres Centers). Weitere Informationen finden Sie in der Datenschutzerklärung von Matterport unter: https://matterport.com/privacy-policy`,
    testId: "datenschutz-matterport",
  },
  {
    title: "11. Soziale Medien",
    text: `Auf unserer Website befinden sich Links zu unseren Profilen in den sozialen Netzwerken Facebook und Instagram (Meta Platforms Ireland Ltd., 4 Grand Canal Square, Dublin 2, Irland).

Es handelt sich dabei um einfache Verlinkungen – es werden beim bloßen Besuch unserer Website keine Daten an diese Netzwerke übertragen. Erst wenn Sie einen Link anklicken, werden Sie auf die jeweilige Plattform weitergeleitet und es gelten deren Datenschutzbestimmungen.

Datenschutzhinweise von Meta/Facebook: https://www.facebook.com/about/privacy
Datenschutzhinweise von Instagram: https://privacycenter.instagram.com/policy`,
    testId: "datenschutz-social",
  },
  {
    title: "12. Ihre Rechte als betroffene Person",
    text: `Sie haben gegenüber uns folgende Rechte hinsichtlich Ihrer personenbezogenen Daten:

• Recht auf Auskunft (Art. 15 DSGVO) – Sie können Auskunft über Ihre von uns verarbeiteten Daten verlangen.
• Recht auf Berichtigung (Art. 16 DSGVO) – Sie können die Berichtigung unrichtiger Daten verlangen.
• Recht auf Löschung (Art. 17 DSGVO) – Sie können die Löschung Ihrer Daten verlangen, sofern keine gesetzliche Aufbewahrungspflicht besteht.
• Recht auf Einschränkung der Verarbeitung (Art. 18 DSGVO) – Sie können die Einschränkung der Verarbeitung Ihrer Daten verlangen.
• Recht auf Datenübertragbarkeit (Art. 20 DSGVO) – Sie können verlangen, dass wir Ihnen Ihre Daten in einem gängigen Format übermitteln.
• Recht auf Widerspruch (Art. 21 DSGVO) – Sie können der Verarbeitung Ihrer Daten jederzeit widersprechen.
• Recht auf Widerruf der Einwilligung (Art. 7 Abs. 3 DSGVO) – Sie können eine erteilte Einwilligung jederzeit widerrufen.

Zur Ausübung Ihrer Rechte wenden Sie sich bitte an: info@pirate-bowling.com`,
    testId: "datenschutz-rechte",
  },
  {
    title: "13. Beschwerderecht bei einer Aufsichtsbehörde",
    text: `Unbeschadet eines anderweitigen verwaltungsrechtlichen oder gerichtlichen Rechtsbehelfs steht Ihnen das Recht auf Beschwerde bei einer Aufsichtsbehörde zu, wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen die DSGVO verstößt.

Zuständige Aufsichtsbehörde:
Bayerisches Landesamt für Datenschutzaufsicht (BayLDA)
Promenade 18
91522 Ansbach
Telefon: +49 (0) 981 180093-0
E-Mail: poststelle@lda.bayern.de
Website: https://www.lda.bayern.de`,
    testId: "datenschutz-beschwerde",
  },
  {
    title: "14. Aktualität und Änderung dieser Datenschutzerklärung",
    text: `Diese Datenschutzerklärung hat den Stand April 2026. Durch die Weiterentwicklung unserer Website oder aufgrund geänderter gesetzlicher bzw. behördlicher Vorgaben kann es notwendig werden, diese Datenschutzerklärung zu ändern. Die jeweils aktuelle Datenschutzerklärung kann jederzeit auf unserer Website abgerufen werden.`,
    testId: "datenschutz-aktualitaet",
  },
];

export default function Datenschutz() {
  usePageMeta({
    title: "Datenschutz – Pirate Bowling Center Velburg",
    description: "Datenschutzerklärung des Pirate Bowling Center Velburg gemäß DSGVO.",
    noindex: true,
  });
  return (
    <div className="min-h-screen bg-navy text-cream">
      <div className="border-b border-gold/10 bg-navy-deep/80 backdrop-blur-xl sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link
            to="/"
            className="inline-flex items-center gap-2 text-cream-muted hover:text-gold transition-colors text-sm font-space-grotesk"
            data-testid="back-home-btn"
          >
            <ArrowLeft className="w-4 h-4" />
            Zurück zur Startseite
          </Link>
          <span className="font-unbounded text-xs font-bold gold-text tracking-widest uppercase">
            Pirate Bowling Center
          </span>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 py-16 md:py-24">
        <div className="mb-12">
          <div className="skull-divider mb-6">
            <span className="font-space-grotesk text-xs text-gold tracking-[0.3em] uppercase px-3">Rechtliches</span>
          </div>
          <h1
            className="font-unbounded text-4xl md:text-5xl font-black text-cream"
            data-testid="datenschutz-headline"
          >
            Datenschutz
          </h1>
        </div>

        <div className="space-y-5">
          {sections.map((sec) => (
            <div
              key={sec.testId}
              className="glass border border-gold/10 rounded-2xl p-8"
              data-testid={sec.testId}
            >
              <h2 className="font-unbounded text-base font-bold text-cream mb-4">{sec.title}</h2>
              <p className="font-inter text-sm text-cream/70 leading-relaxed whitespace-pre-line">{sec.text}</p>
            </div>
          ))}
        </div>
      </div>

      <LegalFooter />
    </div>
  );
}
